(function () {
  function initSliders() {
    const focusableSelector =
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]';

    document.querySelectorAll('[data-testimonial-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-testimonial-track]');
      const slides = Array.from(
        slider.querySelectorAll('[data-testimonial-slide]'),
      );
      if (!track || slides.length === 0) return;

      const perViewSetting =
        parseInt(slider.getAttribute('data-slides-per-view'), 10) || 1;
      const layout = slider.getAttribute('data-layout') || 'grid';
      let perView = Math.max(1, Math.min(perViewSetting, slides.length));
      let index = 0;
      let active = false;

      const shouldActivate = () => {
        if (layout === 'slider') return true;
        return window.matchMedia('(max-width: 1023px)').matches;
      };

      const resolvePerView = () => {
        if (window.matchMedia('(max-width: 639px)').matches) return 1;
        if (window.matchMedia('(max-width: 1023px)').matches)
          return Math.min(2, perViewSetting);
        return Math.max(1, Math.min(perViewSetting, slides.length));
      };

      const maxIndex = () => Math.max(0, slides.length - perView);
      const clamp = (val) => Math.max(0, Math.min(val, maxIndex()));

      const updateSlideAccessibility = () => {
        slides.forEach((slide, slideIndex) => {
          const isVisible =
            !active || (slideIndex >= index && slideIndex < index + perView);
          slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

          slide.querySelectorAll(focusableSelector).forEach((el) => {
            if (isVisible) {
              if (el.hasAttribute('data-a11y-tabindex')) {
                const original = el.getAttribute('data-a11y-tabindex');
                if (original === '') {
                  el.removeAttribute('tabindex');
                } else {
                  el.setAttribute('tabindex', original);
                }
                el.removeAttribute('data-a11y-tabindex');
              }
              return;
            }

            if (!el.hasAttribute('data-a11y-tabindex')) {
              el.setAttribute(
                'data-a11y-tabindex',
                el.getAttribute('tabindex') ?? '',
              );
            }
            el.setAttribute('tabindex', '-1');
          });
        });
      };

      const updateDots = () => {
        if (!dotsWrap || dots.length === 0) return;
        dots.forEach((dot, i) => {
          const isActiveDot = i === index;
          dot.classList.toggle('bg-gray-900', i === index);
          dot.classList.toggle('bg-gray-300', i !== index);
          dot.classList.toggle('w-6', i === index);
          dot.setAttribute('aria-current', isActiveDot ? 'true' : 'false');
        });
      };

      const update = () => {
        index = clamp(index);
        track.style.transform = `translateX(calc(-${index * (100 / perView)}% - ${index * 1}rem))`;
        updateSlideAccessibility();
        updateDots();
      };

      const applyWidths = () => {
        perView = resolvePerView();
        const width = 100 / perView;
        slides.forEach((slide) => {
          slide.style.width = `${width}%`;
        });
        update();
      };

      const clearInline = () => {
        track.style.transform = '';
        slides.forEach((slide) => {
          slide.style.width = '';
        });
      };

      const prev = slider.querySelector('[data-testimonial-prev]');
      const next = slider.querySelector('[data-testimonial-next]');
      if (prev) {
        prev.addEventListener('click', () => {
          if (!active) return;
          index -= 1;
          update();
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          if (!active) return;
          index += 1;
          update();
        });
      }

      const dotsWrap = slider.querySelector('[data-testimonial-dots]');
      let dots = [];
      const buildDots = () => {
        if (!dotsWrap) return;
        dotsWrap.setAttribute('role', 'group');
        dotsWrap.setAttribute('aria-label', 'Testimonial navigation');
        dotsWrap.innerHTML = '';
        const count = maxIndex() + 1;
        dots = Array.from({ length: count }).map((_, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'h-2 w-2 theme-border-radius bg-gray-300 transition';
          btn.setAttribute('aria-label', `Go to testimonial group ${i + 1}`);
          btn.addEventListener('click', () => {
            index = i;
            update();
          });
          dotsWrap.appendChild(btn);
          return btn;
        });
        updateDots();
      };

      const updateState = () => {
        const nextActive = shouldActivate();
        if (nextActive) {
          active = true;
          applyWidths();
          buildDots();
          updateSlideAccessibility();
        } else {
          active = false;
          index = 0;
          clearInline();
          updateSlideAccessibility();
        }
      };

      updateState();
      let resizeTimer = null;
      window.addEventListener('resize', () => {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          updateState();
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }
})();
